import { defineComponent as _defineComponent } from 'vue'
import Divider from '@/components/Divider.vue'
import FormatUtils from '@/utils/format_utils';
import { Icons } from '@/font-awesome';
import { CardCategoryType } from '@/models/benefits_cards/card_category_type';
import { LoadingModalV2Injection } from '@/infra/constants/injections';
import { ReqBenCardsRenewScreens, useReqRenewBenefitsCardPlansStore } from '@/stores/benefits_card_plans/request_renew_benefits_cards_plan_store';
import { inject, Ref } from 'vue';
import CommonButton from '@/components/CommonButton.vue';
import LoadingModalV2 from '../../LoadingModalV2.vue';
import BenefitTypeValue from '@/components/card_benefits_plan/BenefitTypeValue.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { BenefitsCardPlan } from '@/models/benefits_cards/benefits_card_plan_model';


export default /*@__PURE__*/_defineComponent({
  __name: 'PatchBenCardsPlanScreen',
  props: {
    showScreen: { type: Boolean, required: true }
  },
  emits: ["close"],
  setup(__props: any, { expose: __expose }) {
  __expose();

const reqRenewBenCardsPlanStore = useReqRenewBenefitsCardPlansStore;

const props = __props;



const loadingModalV2 = inject<Ref<InstanceType<typeof LoadingModalV2>>>(LoadingModalV2Injection);

async function updatePlan() {
  if (!reqRenewBenCardsPlanStore.validateBenefits({ setErrors: true })) return;
  const res = reqRenewBenCardsPlanStore.updateBenefitsPlan();
  await loadingModalV2?.value?.open({
    promise: res,
    loading: {
      text: 'Atualizando plano de cartão...'
    },
    loaded: {
      text: 'Plano de cartão atualizado'
    },
  });
  const valueResult = await res;
  if (!(valueResult.getValue() instanceof BenefitsCardPlan)) loadingModalV2?.value.closeImmediately();
  if (valueResult.isError()) return;
  reqRenewBenCardsPlanStore.currentScreen = ReqBenCardsRenewScreens.VALUE_CONFIRMATION
}


const __returned__ = { reqRenewBenCardsPlanStore, props, loadingModalV2, updatePlan, Divider, get FormatUtils() { return FormatUtils }, get Icons() { return Icons }, get CardCategoryType() { return CardCategoryType }, CommonButton, BenefitTypeValue, get FontAwesomeIcon() { return FontAwesomeIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})